<template>
  <div class="m-0" v-if="isDeploymentMission">
    <div class="text-xs-center" v-if="displayComputationWidget">
      <exo-mission-computation></exo-mission-computation>
    </div>
    <div v-if="displayResult">
      <v-row>
        <v-col class="pb-3">
          <v-row no-gutters>
            <div class="d-inline-flex align-center">
              <span class="headline ml-3 justify-start grey--text"
                >{{ currentMission.name.toUpperCase() }} {{ mainSummary }}</span
              >
            </div>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  large
                  icon
                  color="primary"
                  v-on="on"
                  @click.stop="dashboardTools().saveLayout(_self)"
                >
                  <icon scale="1.5" class="primary--text" name="save"></icon>
                </v-btn>
              </template>
              <span
                >Save the layout and the configurations of the dashboard</span
              >
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  large
                  icon
                  color="primary"
                  v-on="on"
                  @click.stop="dashboardTools().resetLayout(_self)"
                >
                  <icon
                    scale="1.5"
                    class="primary--text"
                    name="undo-alt"
                  ></icon>
                </v-btn>
              </template>
              <span
                >Reset the layout and the configurations of the dashboard</span
              >
            </v-tooltip>
          </v-row>
        </v-col>
      </v-row>
      <v-divider class="mt-0"></v-divider>
      <div class="px-3">
        <grid-layout
          :layout.sync="gridlayout"
          :col-num="6"
          :row-height="7"
          :is-draggable="true"
          :is-resizable="true"
          :is-mirrored="false"
          :vertical-compact="true"
          :margin="[20, 10]"
          :use-css-transforms="true"
        >
          <grid-item
            :x="gridlayout[0].x"
            :y="gridlayout[0].y"
            :w="gridlayout[0].w"
            :h="gridlayout[0].h"
            :i="gridlayout[0].i"
            :isDraggable="false"
            :isResizable="false"
            v-on:click="click1()"
          >
            <deployment-scenario-card
              color="#38AD38"
              v-if="getConfigurationsNumber > 0"
              :clickedCallback="showDetails"
              :index="0"
              :scenarios="this.currentResultsLog.results.launchConfigurations"
            />
          </grid-item>
          <grid-item
            :x="gridlayout[1].x"
            :y="gridlayout[1].y"
            :w="gridlayout[1].w"
            :h="gridlayout[1].h"
            :i="gridlayout[1].i"
            :isDraggable="false"
            :isResizable="false"
          >
            <deployment-scenario-card
              color="#2A94DE"
              v-if="getConfigurationsNumber > 1"
              :clickedCallback="showDetails"
              :index="1"
              :scenarios="this.currentResultsLog.results.launchConfigurations"
            />
          </grid-item>
          <grid-item
            :x="gridlayout[2].x"
            :y="gridlayout[2].y"
            :w="gridlayout[2].w"
            :h="gridlayout[2].h"
            :i="gridlayout[2].i"
            :isDraggable="false"
            :isResizable="false"
          >
            <deployment-scenario-card
              color="#1D2939"
              v-if="getConfigurationsNumber > 2"
              :clickedCallback="showDetails"
              :index="2"
              :scenarios="this.currentResultsLog.results.launchConfigurations"
            />
          </grid-item>
          <grid-item
            :x="gridlayout[3].x"
            :y="gridlayout[3].y"
            :w="gridlayout[3].w"
            :h="gridlayout[3].h"
            :i="gridlayout[3].i"
            :isDraggable="false"
            :isResizable="false"
          >
            <deployment-scenario-card
              color="#5B2786"
              v-if="getConfigurationsNumber > 3"
              :clickedCallback="showDetails"
              :index="3"
              :scenarios="this.currentResultsLog.results.launchConfigurations"
            />
          </grid-item>
          <grid-item
            :x="gridlayout[4].x"
            :y="gridlayout[4].y"
            :w="gridlayout[4].w"
            :h="gridlayout[4].h"
            :i="gridlayout[4].i"
            :isDraggable="false"
            :isResizable="false"
          >
            <deployment-scenario-details
              v-if="indexDetails >= 0"
              :index="indexDetails"
              :scenarios="this.currentResultsLog.results.launchConfigurations"
            />
          </grid-item>
          <grid-item
            :x="gridlayout[6].x"
            :y="gridlayout[6].y"
            :w="gridlayout[6].w"
            :h="gridlayout[6].h"
            :i="gridlayout[6].i"
            :minH="5"
            :minW="1"
            @resized="statsCardResized"
            @resize="statsCardResized"
          >
            <stats-card
              color="#F72C2C"
              awesomeicon="calendar-check"
              title="Exploitation date"
              :ref="`${statsCardName}${gridlayout[6].i}`"
              :cardId="`${statsCardName}${gridlayout[6].i}`"
              :value="
                computeResultToDisplay([
                  'launchConfigurations',
                  'exploitationDate'
                ])
              "
              :unit="
                getResultUnitLabel(['launchConfigurations', 'exploitationDate'])
              "
            />
          </grid-item>
          <grid-item
            :x="gridlayout[7].x"
            :y="gridlayout[7].y"
            :w="gridlayout[7].w"
            :h="gridlayout[7].h"
            :i="gridlayout[7].i"
            :minH="5"
            :minW="1"
            @resized="statsCardResized"
            @resize="statsCardResized"
          >
            <stats-card
              color="#FF7E0D"
              awesomeicon="cash-register"
              title="Total cost"
              :ref="`${statsCardName}${gridlayout[7].i}`"
              :cardId="`${statsCardName}${gridlayout[7].i}`"
              :value="
                computeResultToDisplay(['launchConfigurations', 'totalCost'])
              "
              :unit="getResultUnitLabel(['launchConfigurations', 'totalCost'])"
            />
          </grid-item>
          <grid-item
            :x="gridlayout[5].x"
            :y="gridlayout[5].y"
            :w="gridlayout[5].w"
            :h="gridlayout[5].h"
            :i="gridlayout[5].i"
            v-if="currentMission"
            :isResizable="false"
          >
            <v-col fill-height d-flex>
              <results-card disableExport :root="_self">
                <exo-form-alert
                  v-if="
                    this.currentResultsLog !== null &&
                    getConfigurationsNumber < getMaxConfigurationNumber
                  "
                >
                  <ul>
                    Warning: Only the first
                    {{
                      getConfigurationsNumber
                    }}
                    configurations on
                    {{
                      getMaxConfigurationNumber
                    }}
                    are displayed.
                  </ul>
                </exo-form-alert>
              </results-card>
            </v-col>
          </grid-item>
          <grid-item
            :x="gridlayout[8].x"
            :y="gridlayout[8].y"
            :w="gridlayout[8].w"
            :h="gridlayout[8].h"
            :i="gridlayout[8].i"
            v-if="isDeploymentOptimizationMission"
            :isDraggable="false"
          >
            <v-col class="fill-height" d-flex>
              <div :id="plotingAreaName" :ref="plotingAreaName"></div>
            </v-col>
          </grid-item>
        </grid-layout>
      </div>
    </div>
  </div>
</template>

<script>
import dashboardComponents from '../../components/Dashboard/index.js'
import dataTools from '../../tools/data.js'
import dashboardTools from '../../tools/dashboard.js'
import { mapGetters } from 'vuex'
import Vue from 'vue'
import errorMixin from '../../mixins/logHandler.js'
import plotInput from '../../mixins/plotInput.js'
import plotLayout from '../../mixins/plotLayout.js'
import plotData from '../../mixins/plotData.js'
import Plotly from 'plotly.js-dist'

Vue.use(dashboardComponents)

export default {
  name: 'DeploymentDashboard',
  mixins: [errorMixin, plotLayout, plotInput, plotData],

  data() {
    return {
      plotingAreaName: 'plotingArea-launchers',
      configurations: [],
      totalNumberOfConfigurations: 0,
      isDrawn: [],
      drawer: false,
      statsCardName: 'statsCard',
      type: 'DeploymentResult',
      configuration: this.buildEmptyConfiguration(),
      defaultLayout: [
        { x: 0, y: 0, w: 1, h: 6, i: '0' },
        { x: 1, y: 0, w: 1, h: 6, i: '1' },
        { x: 2, y: 0, w: 1, h: 6, i: '2' },
        { x: 3, y: 0, w: 1, h: 6, i: '3' },
        { x: 0, y: 1, w: 4, h: 40, i: '4' },
        { x: 4, y: 0, w: 1, h: 22, i: '5' },
        { x: 5, y: 0, w: 1, h: 6, i: '6' },
        { x: 5, y: 1, w: 1, h: 6, i: '7' },
        { x: 4, y: 2, w: 2, h: 29, i: '8' }
      ],
      gridlayout: [
        { x: 0, y: 0, w: 1, h: 6, i: '0' },
        { x: 1, y: 0, w: 1, h: 6, i: '1' },
        { x: 2, y: 0, w: 1, h: 6, i: '2' },
        { x: 3, y: 0, w: 1, h: 6, i: '3' },
        { x: 0, y: 1, w: 4, h: 40, i: '4' },
        { x: 4, y: 0, w: 1, h: 22, i: '5' },
        { x: 5, y: 0, w: 1, h: 6, i: '6' },
        { x: 5, y: 1, w: 1, h: 6, i: '7' },
        { x: 4, y: 2, w: 2, h: 29, i: '8' }
      ],
      indexDetails: 0
    }
  },

  mounted() {
    this.$root.$on('current-results-updated', this.currentResultsUpdatedHandler)

    setTimeout(() => {
      this.loadLayout()
    }, 1)
  },
  beforeDestroy() {
    this.$root.$off(
      'current-results-updated',
      this.currentResultsUpdatedHandler
    )
  },

  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      currentMission: 'currentMission',
      currentResultsLog: 'currentResultsLog'
    }),
    mainSummary() {
      if (this.getConfigurationsNumber > 0) {
        return ' : ' + this.currentResultsLog.results.header
      }
      return ''
    },

    getConfigurationsNumber() {
      return this.currentResultsLog?.results?.launchConfigurations?.length || 0
    },
    getMaxConfigurationNumber() {
      return this.currentResultsLog?.results?.totalNumberOfConfigurations || 0
    },
    displayComputationWidget() {
      return dashboardTools.displayComputationWidget(this)
    },
    displayResult() {
      return dashboardTools.displayResult(this)
    },
    resultLoaded() {
      return dashboardTools.resultLoaded(this)
    },
    isDeploymentMission() {
      return (
        this.currentMission != null &&
        this.currentMission.typeName === 'DeploymentRequest'
      )
    },
    isDeploymentScenarioMission() {
      return (
        this.isDeploymentMission &&
        this.currentMission.type === 'Deployment Scenario'
      )
    },
    isDeploymentOptimizationMission() {
      return (
        this.isDeploymentMission &&
        this.currentMission.type === 'Deployment Optimization'
      )
    },
    resultAvailable() {
      return (
        this.isDeploymentMission &&
        this.resultLoaded &&
        this.currentResultsLog.results ===
          Object(this.currentResultsLog.results)
      ) // check object, not array
    }
  },

  methods: {
    currentResultsUpdatedHandler() {
      setTimeout(() => {
        this.loadLayout()
      }, 1)
      this.removeDuplicatedGridItem()
    },

    showDetails(index) {
      this.indexDetails = index
    },
    dashboardTools() {
      return dashboardTools
    },
    loadLayout() {
      const plotDom = document.getElementById(this.plotingAreaName)
      if (plotDom) {
        try {
          Plotly.purge(this.plotingAreaName)
        } catch (e) {}
      }
      if (this.isDeploymentOptimizationMission && this.resultLoaded) {
        if (this.currentMission.layout) {
          let missionLayout = JSON.parse(this.currentMission.layout)
          dataTools.loadGridLayoutConfig(missionLayout, this)
        } else {
          let missionLayout = { configurations: [], layout: this.defaultLayout }
          dataTools.loadGridLayoutConfig(missionLayout, this)
          if (this.currentResultsLog?.results?.launchConfigurations != null) {
            const costs =
              this.currentResultsLog.results.launchConfigurations.map(
                (configuration) =>
                  dataTools.convertSi2gui('cost', configuration.totalCost)
              )
            const dates =
              this.currentResultsLog.results.launchConfigurations.map(
                (configuration) => configuration.exploitationDate
              )

            let data = [
              {
                x: dates,
                y: costs,
                type: 'scatter',
                mode: 'markers'
              }
            ]
            let layout = {
              title: {
                text: 'Total cost depending on the exploitation date',
                font: {
                  color: this.$vuetify.theme.dark ? 'white' : '#121212'
                }
              },
              plot_bgcolor: this.$vuetify.theme.dark ? '#121212' : 'white',
              paper_bgcolor: this.$vuetify.theme.dark ? '#121212' : 'white',
              xaxis: {
                title: {
                  text: 'Exploitation date',
                  font: {
                    color: this.$vuetify.theme.dark ? 'white' : '#121212'
                  }
                },
                tickformat: '%d/%m/%Y', // https://github.com/d3/d3-time-format/blob/master/README.md
                showline: false,
                showgrid: true,
                gridcolor: this.$vuetify.theme.dark ? 'grey' : '',
                linecolor: this.$vuetify.theme.dark ? 'grey' : '',
                zerolinecolor: this.$vuetify.theme.dark ? 'white' : '#121212',
                tickfont: {
                  color: this.$vuetify.theme.dark ? 'white' : '#121212'
                }
              },
              yaxis: {
                title: {
                  font: {
                    color: this.$vuetify.theme.dark ? 'white' : '#121212'
                  },
                  txt:
                    'Total cost' +
                    this.getResultUnitLabel([
                      'launchConfigurations',
                      'totalCost'
                    ])
                },
                // tickformat: '~s', //https://github.com/d3/d3-format
                showline: false,
                showgrid: true,
                gridcolor: this.$vuetify.theme.dark ? 'grey' : '',
                linecolor: this.$vuetify.theme.dark ? 'grey' : '',
                zerolinecolor: this.$vuetify.theme.dark ? 'white' : '#121212',
                tickfont: {
                  color: this.$vuetify.theme.dark ? 'white' : '#121212'
                }
              },
              autosize: true
            }
            Vue.nextTick(() => {
              Plotly.react(this.plotingAreaName, data, layout, {
                responsive: true
              })

              // Use timeout as workaround because nextTick doesnt work as expected
              /* setTimeout(() => {
                // Not nice but no workaround possible here (used to fit exactly the parent height)
                let el = this.$refs[this.plotingAreaName]
                console.log(el)
                if (el) {
                  let parent = el ? el.$parent : undefined
                  if (parent) {
                    console.log('react')
                    layout.height = parent.$el.clientHeight - 50
                    Plotly.react(this.plotingAreaName, data, layout, {responsive: true})
                  }
                }
              }----
                , 100) */
            })
          }
        }
      }
    },

    removeDuplicatedGridItem() {
      // remove duplicated items (same id
      for (let i = 0; i < this.configurations.length - 1; i++) {
        // remove configurations
        if (
          this.configurations[i].gridItem.i ===
          this.configurations[i + 1].gridItem.i
        ) {
          // same id
          this.configurations.splice(i + 1, 1) // remove the others
        }
      }
      for (let i = 0; i < this.gridlayout.length - 1; i++) {
        // first remove duplicated ids
        if (this.gridlayout[i].i === this.gridlayout[i + 1].i) {
          // same id
          this.gridlayout.splice(i + 1, 1) // remove the others
        }
      }
      // remove ghosts : in the layout but no configuration
      for (let i = 0; i < this.gridlayout.length; i++) {
        let itemId = this.gridlayout[i].i
        if (itemId.startsWith('plot')) {
          let configuration = this.configurations.find(
            (el) => el.gridItem.i === itemId
          )
          if (configuration == null) {
            this.gridlayout.splice(i, 1)
            i = i - 1 // because i should not be increased
          }
        }
      }
    },

    statsCardResized(i) {
      dashboardTools.statsCardResized(this, i)
    },

    plotCardResized(i, newH, newW, newHPx, newWPx) {
      let update = {
        width: newWPx,
        height: newHPx - 50
      }
      let plotingArea = document.getElementById(this.plotingAreaName)
      if (plotingArea != null) {
        try {
          Plotly.relayout(plotingArea, update)
        } catch (e) {
          console.log('Error calling Plotly.relayout')
        }
      }
    },

    computeResultToDisplay(fieldPath) {
      let fieldType = dataTools.getFieldTypeFromPath(fieldPath, this.type, null)
      return this.computeRange(fieldType, fieldPath)
    },

    computeRange(fieldType, fieldPath, results) {
      let currentResults = results
      if (currentResults == null) {
        if (!this.resultAvailable) {
          return ''
        } else {
          currentResults = this.currentResultsLog.results
        }
      }
      let allVals = this.getAllValues(currentResults, fieldPath, null)
      if (allVals.length === 0) {
        return ''
      }
      let min = ''
      let max = ''
      if (fieldType === 'string') {
        allVals.sort()
        min = allVals[0]
        max = allVals[allVals.length - 1]
      } else {
        allVals = allVals.filter((value) => !isNaN(value))
        min = dataTools.convertSi2Display(fieldType, Math.min(...allVals))
        max = dataTools.convertSi2Display(fieldType, Math.max(...allVals))
      }
      if (min === max) {
        return min.toString()
      } else {
        if (min.toString().includes('Infinity')) {
          return ''
        }
        let displayedString = '[' + min
        allVals.length === 2
          ? (displayedString += '; ')
          : (displayedString += ' ... ')
        return displayedString + max + ']'
      }
    },

    getAllValues(currentResults, path, listOfValues) {
      if (listOfValues == null) {
        listOfValues = []
      }
      if (!this.resultAvailable || currentResults == null) {
        return listOfValues
      }
      if (Array.isArray(path) && path.length) {
        let subPath = path.slice() // copy to not change input
        let branchOrLeaf = subPath.shift()
        if (Array.isArray(currentResults) && currentResults.length) {
          for (let singleResultElt of currentResults) {
            listOfValues = this.getAllValues(
              singleResultElt[branchOrLeaf],
              subPath,
              listOfValues
            )
          }
        } else {
          listOfValues = this.getAllValues(
            currentResults[branchOrLeaf],
            subPath,
            listOfValues
          )
        }
      } else {
        // leaf
        listOfValues.push(currentResults)
      }
      return listOfValues
    },

    getResultUnitLabel(fieldPath) {
      return dashboardTools.getResultUnitLabel(this, fieldPath)
    },

    getCurrentAPI() {
      return dashboardTools.getCurrentAPI(this)
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Roboto');
</style>
